import { useMemo, useState, useContext, useRef } from "react";
import { Upload, Button, message, Dropdown, Space } from "antd";
import { UploadOutlined } from "@ant-design/icons";

import FileModal from "@/components/modals/FileModal";
import FileLinkModal from "@/components/modals/FileLinkModal";
import MainContext from "@/layouts/MainLayout/context";

const UploadFile = ({
  value,
  accept = "",
  unit_uuid,
  units = [],
  returnObject = false,
  onKeyDown,
  onComplete,
  onChange,
}) => {
  const { setLayoutPending } = useContext(MainContext);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // Окно создания/редактирования файла
  const [isModalFileShow, setIsModalFileShow] = useState(false);
  const [isSystemModalShow, setIsSystemModalShow] = useState(false);

  const [currentFile, setCurrentFile] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  const uploadRef = useRef(null);
  const buttonRef = useRef(null);

  const defaultFileList = useMemo(() => {
    if (!value || !value.original_name) return [];

    return [
      {
        uid: value.uuid,
        name: value.original_name,
        status: "done",
        url: `/api/file/download?uuid=${value.uuid}`,
      },
    ];
  }, [value]);

  const handleChange = (info) => {
    const { status, name, response } = info.file;

    if (status === "uploading") {
      setIsLoading(true);
      setLayoutPending(true);
    }

    // if (status !== "uploading") {
    //   console.log(info.file, info.fileList);
    // }

    if (status === "done") {
      setIsLoading(false);
      setLayoutPending(false);
      const res = response?.files[0];

      if (res) {
        const name =
          res.original_name.split(".").slice(0, -1).join(".") ||
          res.original_name;
        setCurrentFile({
          ...res,
          name,
          // folder_uuid: data.uuid,
          unit_uuid: unit_uuid,
          isSystem: false,
        });
        onChange?.(null);

        setIsModalFileShow(true);
      }
    } else if (status === "error") {
      setIsLoading(false);
      setLayoutPending(false);
      message.error(`Загрузка файла ${name} не удалась. Попробуйте еще раз.`);
    }
  };

  const handleSaveFile = (uuid = "") => {
    setIsModalFileShow(false);
    if (uuid) {
      const nextFile = { ...currentFile, uuid };
      setCurrentFile(nextFile);
      onChange?.(nextFile);
      onComplete?.(returnObject ? nextFile : uuid);
    } else {
      onChange?.(currentFile);
      onComplete?.(returnObject ? currentFile : currentFile?.uuid);
    }
  };

  const handleSaveFileLink = async (fileLink) => {
    const name =
      (fileLink.name || "Файл из системы").split(".").slice(0, -1).join(".") ||
      fileLink.name;

    setCurrentFile({
      ...fileLink,
      name,
      unit_uuid: unit_uuid,
      isSystem: true,
    });

    onChange?.(null);

    setIsSystemModalShow(false);
    setIsModalFileShow(true);
  };

  const menu = {
    items: [
      { key: "device", label: "Выбрать файл с устройства" },
      { key: "system", label: "Выбрать файл из системы" },
    ],
    onClick: ({ key }) => {
      if (key === "device") {
        uploadRef.current?.querySelector("input")?.click();
      }
      if (key === "system") {
        setIsSystemModalShow(true);
      }
    },
    onKeyDown: (e) => {
      if (e.key !== "Enter") {
        onKeyDown?.(e);
      }
    },
  };

  const focusNextMenuItem = (key) => {
    const items = Array.from(
      document.querySelectorAll(".uploadfile-dropdown .ant-dropdown-menu-item"),
    );
    if (!items.length) return;
    if (key === "ArrowDown") items[0]?.focus();
    if (key === "ArrowUp") items[items.length - 1]?.focus();
  };

  return (
    <>
      <Space orientation="vertical" style={{ width: "100%" }} size="small">
        <Dropdown
          menu={menu}
          trigger={["click"]}
          placement="bottomLeft"
          getPopupContainer={() => document.body}
          classNames={{ root: "uploadfile-dropdown" }}
          onOpenChange={(open) => setIsDropdownOpen(open)}
        >
          <Button
            ref={buttonRef}
            data-focus-edit-button="true"
            icon={<UploadOutlined />}
            loading={isLoading}
            disabled={isLoading}
            onKeyDown={(e) => {
              if (e.key === "ArrowDown" || e.key === "ArrowUp") {
                if (isDropdownOpen) {
                  e.preventDefault();
                  focusNextMenuItem(e.key);
                  return;
                }
              } else if (e.key !== "Enter") {
                onKeyDown?.(e);
              }
            }}
          >
            Выбрать файл
          </Button>
        </Dropdown>

        {value && (
          <Upload
            fileList={defaultFileList}
            showUploadList={{ showPreviewIcon: true, showRemoveIcon: true }}
            onRemove={() => {
              onChange?.(null);
              onComplete?.(null);
            }}
          />
        )}
      </Space>

      <div
        style={{
          position: "absolute",
          width: 0,
          height: 0,
          overflow: "hidden",
        }}
        ref={uploadRef}
      >
        <Upload
          name="file"
          action="/api/file/upload"
          accept={accept}
          onChange={handleChange}
          showUploadList={false}
          multiple={false}
        />
      </div>

      {isModalFileShow && (
        <FileModal
          data={currentFile}
          visible={isModalFileShow}
          onSave={handleSaveFile}
          onCancel={() => setIsModalFileShow(false)}
          disableUnit
          units={units}
        />
      )}

      {isSystemModalShow && (
        <FileLinkModal
          visible={isSystemModalShow}
          onCancel={() => setIsSystemModalShow(false)}
          onSave={handleSaveFileLink}
          unit_uuid={unit_uuid}
        />
      )}
    </>
  );
};

export default UploadFile;
